export const a11y = {
    ariaDescriptionTrigger: 'Select to learn more',
    /**
     * When users specify the `topic` prop for the dejarg trigger,
     * the `topic` will be passed into this function in order to create
     * the full aria-label for the trigger
     */
    getAriaLabelTrigger: (topic) => `Select to learn more about ${topic}`,
};
//# sourceMappingURL=strings.js.map